var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconAlarmBellSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25.75h3l-3 3.75h3m-9 2.25H18l-3.75 4.5H18M7.748 21.75a2.087 2.087 0 0 0 4.005 0M9.75 3V.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.965 3.75A7.424 7.424 0 0 0 9.75 3a7.5 7.5 0 0 0-7.5 7.5c0 5.888-1.5 8.25-1.5 8.25h18a10.017 10.017 0 0 1-1.25-3.663",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconAlarmBellSleep);
export default __webpack_public_path__ + "static/media/streamline-icon-alarm-bell-sleep.6f239fe4.svg";
export { ForwardRef as ReactComponent };